// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bU4k","colBig":"styles_colBig__1yZd-","colSmall":"styles_colSmall___OsSP","shopifyNameWrapper":"styles_shopifyNameWrapper__2gbwS"};